import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { MapOnboardingTooltip } from '../../../../components/MapOnboardingTooltip';
import { MAX_DISPLAY_FUTURE_ONBOARDING_COUNT } from '../../../../constants/map';
import { useApplicationContext } from '../../../../utils/applicationContext';
import {
  getFutureInfrastructureOnboardingCookie,
  getIsFutureMapOnboardingEnabled,
  setFutureInfrastructureOnboardingCookie,
} from './helpers';

interface IFutureInfrastructureOnboardingProps {
  children: React.ReactElement;
}

export const FutureInfrastructureOnboarding: React.FC<IFutureInfrastructureOnboardingProps> = ({ children }) => {
  const [open, setOpen] = React.useState(true);
  const [timesShown, setTimesShown] = React.useState(0);
  const { config } = useApplicationContext();

  const isFutureMapOnboardingEnabled = getIsFutureMapOnboardingEnabled(config);

  React.useLayoutEffect(() => {
    setTimesShown(getFutureInfrastructureOnboardingCookie());
  }, []);

  const hideOnboardingTooltip = React.useCallback(() => {
    setOpen(false);
    setFutureInfrastructureOnboardingCookie(MAX_DISPLAY_FUTURE_ONBOARDING_COUNT);
  }, [isFutureMapOnboardingEnabled]);

  const handleShow = React.useCallback(() => {
    setFutureInfrastructureOnboardingCookie(timesShown + 1);
  }, [timesShown]);

  if (isFutureMapOnboardingEnabled && timesShown < MAX_DISPLAY_FUTURE_ONBOARDING_COUNT) {
    const onboardingContent = (
      <ActionAfterViewObserver triggerOnce callback={handleShow} percentVisible={1}>
        <span>Посмотрите, что появится рядом с ЖК</span>
      </ActionAfterViewObserver>
    );

    return (
      <>
        {open && <MapOnboardingTooltip content={onboardingContent} onClose={hideOnboardingTooltip} placement="right" />}
        <span onClick={hideOnboardingTooltip}>{children}</span>
      </>
    );
  }

  return children;
};
